<!-- =========================================================
     CREATE RESTAURANT MODAL
========================================================= -->

<app-create-app
  *ngIf="AppService.isApp"
  [domain]="domain"
  (reloadapps)="get()"
></app-create-app>


<!-- =========================================================
     GLOBAL LOADING STATES
========================================================= -->

<app-spinner
  *ngIf="load_delete"
  [loading]="load_delete"
  [fullScreen]="true"
  [text]="'Deleting in progress, please wait'"
></app-spinner>

<app-spinner
  *ngIf="load_check"
  [loading]="load_check"
  [fullScreen]="true"
  [text]="'ვამოწმებთ დომენს'"
></app-spinner>


<!-- =========================================================
     ERROR STATE
========================================================= -->

<app-error
  *ngIf="error"
  [title]="''"
></app-error>


<!-- =========================================================
     MY RESTAURANTS PAGE
========================================================= -->

<section
  class="restaurants-page"
  *ngIf="!error"
>

  <!-- =====================================================
       PAGE HEADER
  ====================================================== -->
  <app-create-app
    *ngIf="AppService.isApp"
    [domain]="domain"
    (reloadapps)="get()"
  ></app-create-app>
  
  <header class="restaurants-header">

    <div class="restaurants-header__content">

      <span class="restaurants-header__eyebrow">
        MENULOAD WORKSPACES
      </span>

      <h1>
        კეთილი იყოს შენი დაბრუნება
        <span *ngIf="admin.user?.name">
          , {{ admin.user?.name }}
        </span>
      </h1>

      <p>
        აირჩიე რესტორანი და გააგრძელე მისი მართვა.
      </p>

    </div>

    <button
      type="button"
      class="create-restaurant-button"
      (click)="AppService.isApp = true"
    >
      <i class="fi fi-rr-plus"></i>
      <span>ახალი რესტორანი</span>
    </button>

  </header>




  <!-- =====================================================
       LIST HEADER
  ====================================================== -->

  <div class="restaurants-section-header">

    <div>
      <h2>შენი რესტორნები</h2>

      <p *ngIf="data?.length">
        აირჩიე სამუშაო სივრცე, რომლის მართვაც გსურს.
      </p>
    </div>

    <div
      class="restaurants-count"
      *ngIf="!load && data?.length"
    >
      <strong>{{ data.length }}</strong>

      <span>
        restaurant{{ data.length === 1 ? '' : 's' }}
      </span>
    </div>

  </div>


  <!-- =====================================================
       LOADING STATE
  ====================================================== -->

  <div
    class="restaurants-loading"
    *ngIf="load"
  >
    <app-spinner
      [loading]="load"
      [text]="'Restaurants are loading...'"
    ></app-spinner>
  </div>


  <!-- =====================================================
       EMPTY STATE
  ====================================================== -->

  <div
    class="restaurants-empty"
    *ngIf="!load && (!data || data.length === 0)"
  >

    <div class="restaurants-empty__icon">
      <i class="fi fi-rr-store-alt"></i>
    </div>

    <span class="restaurants-empty__eyebrow">
      GET STARTED
    </span>

    <h3>
      შექმენი შენი პირველი რესტორანი
    </h3>

    <p>
      შექმენი ონლაინ მენიუ, დაამატე პროდუქტები და დაიწყე
      შეკვეთების მიღება რამდენიმე წუთში.
    </p>

    <button
      type="button"
      (click)="AppService.isApp = true"
    >
      <i class="fi fi-rr-plus"></i>
      შექმენი პირველი რესტორანი
    </button>

  </div>


  <!-- =====================================================
       RESTAURANT CARDS
  ====================================================== -->

  <div
    class="restaurants-grid"
    *ngIf="!load && data?.length"
  >

    <article
      class="restaurant-card"
      *ngFor="let item of data"
      [class.restaurant-card--warning]="
        item.payment_status === 'unpaid'
      "
    >

      <!-- Payment alert -->

      <div
        class="restaurant-card__payment"
        *ngIf="item.payment_status === 'unpaid'"
      >

        <div class="restaurant-card__payment-info">

          <span class="restaurant-card__payment-icon">
            <i class="fi fi-rr-exclamation"></i>
          </span>

          <div>
            <strong>გადახდა საჭიროა</strong>

            <small>
              მომსახურების გასაგრძელებლად განაახლე პაკეტი.
            </small>
          </div>

        </div>

        <button
          type="button"
          (click)="openPayModal(item)"
        >
          განახლება
        </button>

      </div>


      <!-- Card header -->

      <header class="restaurant-card__header">

        <div class="restaurant-card__identity">

          <div class="restaurant-card__logo">
            {{
              item?.sub_domain
                ? item.sub_domain.charAt(0).toUpperCase()
                : 'M'
            }}
          </div>

          <div class="restaurant-card__title">

            <h3>
              {{ item.sub_domain }}
            </h3>

            <a
              href="https://{{ item.sub_domain }}.menuload.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.sub_domain }}.menuload.com

              <i class="fi fi-rr-arrow-up-right-from-square"></i>
            </a>

          </div>

        </div>


        <!-- Status -->

        <div
          class="restaurant-card__status"
          [class.restaurant-card__status--warning]="
            item.payment_status === 'unpaid'
          "
        >
          <span></span>

          {{
            item.payment_status === 'unpaid'
              ? 'Payment required'
              : 'Active'
          }}
        </div>

      </header>


      <!-- Expiry information -->

      <div class="restaurant-card__meta">

        <div class="restaurant-card__meta-item">

          <span>
            <i class="fi fi-rr-calendar"></i>
          </span>

          <div>
            <small>Package expires</small>

            <strong>
              {{
                item.payment_expiry_date
                  | date: 'dd.MM.yyyy'
              }}
            </strong>
          </div>

        </div>

      </div>


      <!-- Quick navigation -->

      <div class="restaurant-card__navigation">

        <a
          [routerLink]="['/app/orders', item.id]"
          class="restaurant-navigation-item"
        >
          <span class="restaurant-navigation-item__icon">
            <i class="fi fi-rr-order-history"></i>
          </span>

          <strong>Orders</strong>
        </a>


        <a
          [routerLink]="['/app/products', item.id]"
          class="restaurant-navigation-item"
        >
          <span class="restaurant-navigation-item__icon">
            <i class="fi fi-rr-hamburger-soda"></i>
          </span>

          <strong>Menu</strong>
        </a>


        <a
          [routerLink]="['/app/analitic', item.id]"
          class="restaurant-navigation-item"
        >
          <span class="restaurant-navigation-item__icon">
            <i class="fi fi-rr-chart-histogram"></i>
          </span>

          <strong>Analytics</strong>
        </a>


        <a
          [routerLink]="['/app/setting', item.id]"
          class="restaurant-navigation-item"
        >
          <span class="restaurant-navigation-item__icon">
            <i class="fi fi-rr-settings"></i>
          </span>

          <strong>Settings</strong>
        </a>

      </div>


      <!-- Card footer -->

      <footer class="restaurant-card__footer">

        <div class="restaurant-card__secondary-actions">

          <button
            type="button"
            class="restaurant-card__icon-button"
            aria-label="QR code"
            title="QR code"
            (click)="openQrModal(item)"
          >
            <i class="fi fi-rr-qrcode"></i>
          </button>


          <a
            href="https://{{ item.sub_domain }}.menuload.com"
            target="_blank"
            rel="noopener noreferrer"
            class="restaurant-card__icon-button"
            aria-label="Open restaurant website"
            title="Open website"
          >
            <i class="fi fi-rr-arrow-up-right-from-square"></i>
          </a>


          <button
            type="button"
            class="restaurant-card__icon-button"
            [disabled]="updateLoad"
            aria-label="Update restaurant website"
            title="Update website"
            (click)="updateSite(item.sub_domain, item.id)"
          >
            <i
              class="fi fi-rr-refresh"
              [class.is-spinning]="updateLoad"
            ></i>
          </button>

        </div>


        <button
          type="button"
          class="restaurant-card__manage-button"
          (click)="navigateToProducts(item.id)"
        >
          <span>მართვის დაწყება</span>

          <i class="fi fi-rr-arrow-small-right"></i>
        </button>

      </footer>

    </article>

  </div>


  <!-- =====================================================
       SUPPORT
  ====================================================== -->

  <div
    class="restaurants-support"
    *ngIf="!load"
  >

    <div class="restaurants-support__content">

      <span class="restaurants-support__icon">
        <i class="fi fi-rr-headset"></i>
      </span>

      <div>
        <strong>
          გჭირდება დახმარება?
        </strong>

        <small>
          Menuload-ის გუნდი დაგეხმარება რესტორნის,
          მენიუსა და შეკვეთების გამართვაში.
        </small>
      </div>

    </div>

    <a href="mailto:info@menuload.com">
      მხარდაჭერასთან დაკავშირება

      <i class="fi fi-rr-arrow-small-right"></i>
    </a>

  </div>

</section>